module.exports = __webpack_public_path__ + "static/1-6005b8685fa4dbdb59c7aba283712dce.jpg";